import { render, staticRenderFns } from "./PositionsPicker.vue?vue&type=template&id=7a053d63"
import script from "./PositionsPicker.vue?vue&type=script&lang=js"
export * from "./PositionsPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports